import { computed, defineComponent, inject, ref, Component } from 'vue';

import { IPersonalityType } from "@/interfaces/state.interface";
import { IStore } from "@/interfaces/state.interface";

import { PersonalityTestTracker } from "@/classes/tracker";
import AnimatedValue from '@/presentation/components/results/animated-value/animated-value.vue';

export default defineComponent({
	components: {
		AnimatedValue: AnimatedValue as Component
	},
	setup: () => {
		const store = inject('store') as IStore;
		const selectedTypeIndex = ref(1);
		const personalityTypes = computed((): IPersonalityType[] => {
			return store.getters.personalityTypes();
		});
		const selectedType = computed((): IPersonalityType | null => {
			if (selectedTypeIndex.value >= personalityTypes.value.length) {
				return null;
			}

			return personalityTypes.value[selectedTypeIndex.value];
		});

		const setSelectedType = (index: number, trait: string): void => {
			if (selectedTypeIndex.value !== index) {
				PersonalityTestTracker.fireTracking(`personality_selected`, trait, index.toString());
			}

			selectedTypeIndex.value = index;
		};

		return { selectedTypeIndex, personalityTypes, selectedType, setSelectedType };
	}
});
